import { render, staticRenderFns } from "./VoiceRecording.vue?vue&type=template&id=67bd7eca&scoped=true&"
import script from "./VoiceRecording.vue?vue&type=script&lang=js&"
export * from "./VoiceRecording.vue?vue&type=script&lang=js&"
import style0 from "./VoiceRecording.vue?vue&type=style&index=0&id=67bd7eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd7eca",
  null
  
)

export default component.exports